import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Label } from '@/components/ui/label';
import { CurrencySelect } from '@/components/currency-select';

interface BaseCurrencySelectProps {
  currencies: string[];
  editable: boolean;
}

/**
 * Base currency select component
 * Handles base currency selection using React Hook Form with Controller
 */
export const BaseCurrencySelect = ({ currencies, editable }: BaseCurrencySelectProps) => {
  const { t } = useTranslation(['stores', 'common']);
  const {
    control,
    formState: { errors },
  } = useFormContext<{ baseCurrency: string }>();

  return (
    <div id="store-currency-select" className="space-y-2">
      <div className="flex items-center gap-1">
        <Label>{t('form.reportingCurrency')}</Label>
        <span className="text-red-500">*</span>
      </div>
      <p className="text-xs text-gray-500">
        {t('form.reportingCurrencyDescription')}
      </p>
      <Controller
        name="baseCurrency"
        control={control}
        render={({ field: { onChange, value } }) => (
          <CurrencySelect
            disabled={!editable}
            currencies={currencies}
            value={value || ''}
            onChange={onChange}
            placeholder={t('form.selectCurrency')}
          />
        )}
      />
      {errors.baseCurrency && <p className="text-sm text-red-500">{errors.baseCurrency.message as string}</p>}
    </div>
  );
};
